import React, {useState} from 'react';
import ReactDOM from 'react-dom';

function CustomSelectUniversity(props) {
    const [selectedUniv, setSelectedUniv] = useState(null);

    const univs = {}

    for(let option of props.options) {
        const univ = option[3];
        const career = option[2];
        const redirectOnSelect = option[4]
        const id = option[0];
        if(!univs[univ]) {
            univs[univ] = [];
        }

        univs[univ].push([id, career, redirectOnSelect])
    }

    return (
        <div className="container">
            <select required onChange={(e) => {
                setSelectedUniv(e.target.value)
            }}>
                <option disabled selected>Selecciona</option>
                {Object.keys(univs).map(univ => (
                    <option key={`option_${univ}`}>{univ}</option>
                ))}
            </select>
            {selectedUniv && (
                <select
                    onChange={(e) => {
                        if(e.target.value == '0') return;
                        const redirect = e.target.options[e.target.selectedIndex].attributes['data-redirect'].value
                        if(redirect && redirect != 'false') window.location = redirect
                        // if(props.redirectOnSelectForPublic) window.location = e.target.value
                }
                } style={{marginLeft: 18}} required name={props.selectName}>
                    <option disabled selected value={"0"}>Selecciona</option>

                    {(univs[selectedUniv].map(u => (<option data-redirect={u[2] ? u[2] : false}  key={`option_${u[0]}`} value={u[0]}>{u[1]}</option>)))}
                </select>
            )}

        </div>
    );
}

export default CustomSelectUniversity;

if (document.getElementById('custom-select-career')) {

    const elm = document.getElementById('custom-select-career');
    const selectName = elm.querySelector('select').name
    const currentChoices = [
        ...document.getElementById('custom-select-career')
            .querySelector('select').options
    ].slice(1)
        .map(o => [
            o.value,
            o.innerText,
            o.attributes['data-career-name'].value,
            o.attributes['data-university-name'].value,
            o.attributes['data-redirect-on-select'] ? o.attributes['data-redirect-on-select'].value : false
        ])
    ReactDOM.render(<CustomSelectUniversity selectName={selectName} options={currentChoices} />, document.getElementById('custom-select-career'));
}
